import { Block, State } from "../types";

export type ConfidenceClass = "" | "human-edited-no-value" | "human-edited" | "low-confidence" | "high-confidence";

export const getConfidenceClass = (
  block: Block,
  confidenceThreshold: number,
  values: State["values"],
): ConfidenceClass => {
  if (block.references.length < 1) {
    return "";
  }
  let toReturn: ConfidenceClass = "human-edited";
  for (const reference of block.references) {
    if (!(reference in values)) {
      continue;
    }
    const value = values[reference];
    if (value.confidence >= 1 && value.valueRaw.trim().length > 0) {
      continue;
    } else if (value.confidence >= 1 && value.valueRaw.trim().length === 0) {
      return "human-edited-no-value";
    } else if (value.confidence < confidenceThreshold) {
      return "low-confidence";
    } 
    toReturn = "high-confidence";
  }
  return toReturn;
};

export interface ReferencesConfidenceClasses {
  [refId: string]: ConfidenceClass;
}

export const getReferencesConfidenceClasses = (
  block: Block,
  confidenceThreshold: number,
  values: State["values"],
): ReferencesConfidenceClasses => {
  if (block.references.length < 1) {
    return {};
  }
  return block.references.reduce((prev: ReferencesConfidenceClasses, next) => {
    if (!(next in values)) {
      return prev;
    }
    const value = values[next];
    if (value.confidence >= 1) {
      prev[next] = "human-edited";
    } else if (value.confidence < confidenceThreshold) {
      prev[next] = "low-confidence";
    } else {
      prev[next] = "high-confidence";
    }
    return prev;
  }, {});
};
